module.exports = {"130684001":"和平街道","130684002":"军城街道","130684003":"东盛街道","130684004":"北城街道","130684005":"兴华路街道","130684100":"方官镇","130684101":"新城镇","130684102":"泗庄镇","130684104":"辛立庄镇","130684105":"东马营镇","130684106":"辛桥镇","130684200":"肖官营乡","130684201":"梁家营乡","130684202":"张六庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130684.json
// module id = 159
// module chunks = 0